<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ExpertRessourcesEvaluations'
});
</script>
<template>
  <ka-container
    code="expert-ressource-7-evaluation"
    :data="page.$info.expertRessource7Evaluation">
    <!-- Ressources - Experts -->
    <ka-container code="ressources-experts">
      <!-- Titrage -->
      <ka-container code="titrage">
        <ka-text
          code="toutes-les-ressources"
          :options="{
            href: { name: `hub-expert-Ressources` },
            click: page.toutesLesRessourcesClick
          }"
          :xs="{ hidden: null }">
          <span v-html="t('expertRessource7Evaluation.ressourcesExperts.titrage.toutesLesRessources.value', `< Toutes les ressources`)" />
        </ka-text>
        <ka-text code="fin-de-formation">
          <h1 v-html="t('expertRessource7Evaluation.ressourcesExperts.titrage.finDeFormation.value', `Fin de formation <br>= évaluations`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container" />
      </ka-container>
      <!-- Gauche -->
      <ka-container code="gauche">
        <ka-text code="deux-evaluations-permettent">
          <span v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.deuxEvaluationsPermettent.value', `<span style='background-color:transparent;color:#000000;'>Deux évaluations permettent de conclure la formation. La première est consacrée à <strong>la pratique</strong> et la seconde à <strong>la théorie</strong>.</span>`)" />
        </ka-text>
        <ka-text code="titre">
          <h2 v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.titre.value', `Les 5 éléments indispensables pour la clôture d’une formation`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-1">
          <!-- Container -->
          <ka-container code="container-2">
            <ka-icon
              code="icon"
              value="i-fa-solid:check-circle"
              inner />
            <ka-text code="toutes-les-feuilles">
              <span v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.container1.container2.toutesLesFeuilles.value', `<span style='background-color:transparent;color:#000000;'>Toutes les <strong>feuilles d’émargement </strong>doivent être signées par l’expert et les apprenants.</span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-3">
            <ka-icon
              code="icon-1"
              value="i-fa-solid:check-circle"
              inner />
            <ka-text code="le-support-de-formation">
              <span v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.container1.container3.leSupportDeFormation.value', `Le <strong>support de formation </strong>doit être déposé dans le dossier formateur.`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-4">
            <ka-icon
              code="icon-2"
              value="i-fa-solid:check-circle"
              inner />
            <ka-text code="remplir-le-questionnaire">
              <span v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.container1.container4.remplirLeQuestionnaire.value', `<span style='background-color:transparent;color:#000000;'>Remplir le <strong>questionnaire de satisfaction.</strong></span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-5">
            <ka-icon
              code="icon-3"
              value="i-fa-solid:check-circle"
              inner />
            <ka-text
              code="envoyer-un-qcm-devaluation"
              :options="{
                href: { hash: `#evaluer-les-apprentissages--p122` },
                ariaLabel: `text`,
                click: page.envoyerUnQcmDevaluationClick
              }">
              <span v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.container1.container5.envoyerUnQcmDevaluation.value', `Envoyer un QCM d’évaluation aux apprenants. <span style='color:#1100A2FF;'>(Évaluation théorique) </span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-6">
            <ka-icon
              code="icon-4"
              value="i-fa-solid:check-circle"
              inner />
            <ka-text
              code="renseigner-les-mises"
              :options="{
                href: { hash: `#evaluer-les-apprentissages--p122` },
                ariaLabel: `text`,
                click: page.renseignerLesMisesClick
              }">
              <span v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.container1.container6.renseignerLesMises.value', `Renseigner les mises en pratique effectuées durant la formation. <span style='color:#1100A2FF;'>(Évaluation pratique) </span>`)" />
            </ka-text>
          </ka-container>
          <ka-text code="texte">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.container1.texte.value', `⚠️ Sans ces éléments Matchers ne peut pas clôturer la formation et lancer facturation. `)" />
          </ka-text>
        </ka-container>
        <ka-text code="text-1">
          <span v-html="t('expertRessource7Evaluation.ressourcesExperts.gauche.text1.value', `<span style='background-color:transparent;color:#000000;'><strong>+ BONUS : </strong>nous</span><a href='https://www.google.com/maps/place/Matchers/&#64;43.6311487,3.8565037,17z/data=!3m1!4b1!4m6!3m5!1s0x12b6a522d31de6e5:0x21ea890f88ab09f4!8m2!3d43.6311487!4d3.8565037!16s%2Fg%2F11j3xcv1sw?entry=ttu'><span style='background-color:transparent;color:#D93174FF;'> laisser un avis google</span></a><span style='background-color:transparent;color:#000000;'>. Notre équipe est toujours ravie de lire vos retours <strong>❤️</strong></span>`)" />
        </ka-text>
      </ka-container>
      <!-- Droite -->
      <ka-container
        code="droite"
        :xs="{ hidden: null }">
        <!-- Container 2 -->
        <ka-container code="container-7">
          <ka-text code="text-2">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.droite.container7.text2.value', `Autres ressources disponibles :`)" />
          </ka-text>
          <BlocPreviewRessourceSansDescription
            instance-class="preview-ressource-short--p122"
            :options="{
              href: { name: `hub-expert-Ressources-construire-support-de-formation` },
              click: page.previewRessourceShortClick
            }"
            title="<strong>Comment créer mon support de formation ?</strong>"
            image="https://ucarecdn.com/a2a44513-0560-4647-bf8d-08185038c949/" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-1--p122"
            :options="{
              href: { name: `Expert-Ressources-posture-du-formateur` },
              click: page.element1Click
            }"
            title="Quel est la <strong>posture de l'expert </strong>Matchers ? "
            image="https://images.unsplash.com/photo-1584462746497-276f4aeb9fca?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwzMHx8YmFja3xlbnwwfHx8fDE2OTIyODcxNDF8MA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-2--p122"
            :options="{
              href: { name: `Expert-Ressources-animer-la-formation` },
              click: page.element2Click
            }"
            title="<strong>Animer la formation</strong>"
            image="https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw5fHxwciVDMyVBOXNlbnRhdGlvbnxlbnwwfHx8fDE2OTIyNjA3OTJ8MA&ixlib=rb-4.0.3&q=80&w=1080" />
        </ka-container>
      </ka-container>
      <ka-text code="evaluer-les-apprentissages">
        <h2 v-html="t('expertRessource7Evaluation.ressourcesExperts.evaluerLesApprentissages.value', `Évaluation théorique VS évaluation pratique `)" />
      </ka-text>
      <ka-text code="ces-deux-evaluations">
        <span v-html="t('expertRessource7Evaluation.ressourcesExperts.cesDeuxEvaluations.value', `Ces deux évaluations doivent être remises en fin de formation mais vous pouvez très bien commencer à les créer en début de formation et les alimenter au fur e à mesure des sessions de formation .`)" />
      </ka-text>
      <!-- Container -->
      <ka-container code="container-8">
        <ka-image
          code="image-2"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image 2`
          }"
          value="https://ucarecdn.com/3e375b6f-12eb-4454-92ff-708bbd7691fe/" />
        <ka-image
          code="image-3"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image 3`
          }"
          value="https://ucarecdn.com/7ccf589e-1615-4d6c-8ec0-846408449e37/-/crop/1496x748/0,0/-/preview/" />
      </ka-container>
      <!-- Tableau part1 -->
      <ka-container code="tableau-part-1">
        <!-- Ligne 1 -->
        <ka-container code="ligne-1">
          <ka-text
            code="text-3"
            :xs="{ hidden: null }" />
          <ka-text code="evaluation-theorique">
            <h3 v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne1.evaluationTheorique.value', `Évaluation théorique.<br>(Quizz)`)" />
          </ka-text>
          <ka-text code="evaluation-pratique">
            <h3 v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne1.evaluationPratique.value', `Évaluation pratique.<br>(Document écrit)`)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 2 -->
        <ka-container code="ligne-2">
          <ka-text code="quelle-forme">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne2.quelleForme.value', `<span style='background-color:transparent;color:#000000;'><strong>Quelle forme </strong></span><br><span style='background-color:transparent;color:#000000;'><strong>a-t-elle ?</strong></span>`)" />
          </ka-text>
          <ka-text code="un-qcm-cree-avec">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne2.unQcmCreeAvec.value', `<span style='background-color:transparent;color:#000000;'>Un <strong>QCM</strong> créé avec l’outil de création de questionnaire google.</span><br> <br><span style='background-color:transparent;color:#000000;'><i><strong>(google form)</strong></i></span>`)" />
          </ka-text>
          <ka-text code="un-compte-rendu-ecrit">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne2.unCompteRenduEcrit.value', `Un <strong>compte rendu écrit</strong> dans un tableau.<br> <br><i><strong>(google sheets)</strong></i>`)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 3 -->
        <ka-container code="ligne-3">
          <ka-text code="ou-trouver-le-modele">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne3.ouTrouverLeModele.value', `Où trouver le modèle ?`)" />
          </ka-text>
          <ka-text code="sur-le-drive-dans">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne3.SurLeDriveDans.value', `👉  Sur le drive, dans votre dossier formateur.`)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 4 -->
        <ka-container code="ligne-4">
          <ka-text code="que-doit-faire-lexpert">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne4.queDoitFaireLexpert.value', `Que doit faire l’expert ?`)" />
          </ka-text>
          <ka-text code="la-1-ere-rubrique-est">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne4.la1EreRubriqueEst.value', `La 1ère rubrique est générique. Vous n'avez rien à faire.<br> <br>En revanche, dans les rubriques suivantes (2/6) vous devez créer et personnaliser des questions d’après l'accompagnement que vous avez réalisé.`)" />
          </ka-text>
          <ka-text code="nommer-et-detailler">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne4.nommerEtDetailler.value', `<ul><li>Nommer et détailler les mises en pratique que les apprenants ont réalisés au cours de la formation (colonne B et C).</li></ul><p> </p><ul><li>Préciser sur quels éléments vous vous appuyer pour réaliser l'évaluation (colonne D).</li></ul><p> </p><ul><li>Renseigner votre évaluation (colonne E et F).</li></ul>`)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 5 -->
        <ka-container code="ligne-5">
          <ka-text code="quand-doit-elle-etre">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne5.quandDoitElleEtre.value', `Quand doit-elle être faite ?`)" />
          </ka-text>
          <ka-text code="des-reception-du-mail">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne5.desReceptionDuMail.value', `Dès réception du mail vous indiquant de créer les évaluations.`)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 6 -->
        <ka-container code="ligne-6">
          <ka-text code="et-apres">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne6.etApres.value', `Et après ? `)" />
          </ka-text>
          <ka-text code="vous-devez-lenvoyer">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne6.vousDevezLenvoyer.value', `Vous devez l’envoyer aux apprenants d’après les indications du mail. `)" />
          </ka-text>
          <ka-text code="vous-navez-plus-rien">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne6.vousNavezPlusRien.value', `Vous n’avez plus rien à faire 👌`)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 7 -->
        <ka-container code="ligne-7">
          <ka-text code="que-mettre-dedans">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne7.queMettreDedans.value', `Que mettre dedans ?`)" />
          </ka-text>
          <ka-text code="questions-a-choix">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne7.questionsAChoix.value', `<ul><li>Questions à choix multiples</li><li>vrai/faux</li><li>oui/non</li></ul>`)" />
          </ka-text>
          <ka-text code="toutes-les-mises-en">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPart1.ligne7.toutesLesMisesEn.value', `Toutes les mises en application/manipulations opérationnelles/ cas pratiques vus pendant les sessions ou faits entre les sessions par les apprenants. `)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Container promo parrainage -->
      <ka-container code="container-promo-parrainage">
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Image `
          }"
          value="https://ucarecdn.com/468f6f34-6290-43d2-8c14-59533fdd09f1/" />
        <!-- Container -->
        <ka-container code="container-9">
          <ka-text code="gagnez-200-en-parrainant">
            <h2 v-html="t('expertRessource7Evaluation.ressourcesExperts.containerPromoParrainage.container9.gagnez200EnParrainant.value', `Gagnez 200€ en parrainant Matchers`)" />
          </ka-text>
          <ka-text code="vous-connaissez-peut-etre">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.containerPromoParrainage.container9.vousConnaissezPeutEtre.value', `Vous connaissez peut-être une startup, un e-commerçant ou un commerçant susceptible d'être intéressé par une formation Matchers ? Vous pouvez nous partager le contact d'un.e dirigeant.e ou chargé.e des ressources humaines. `)" />
          </ka-text>
          <ka-button
            code="je-minscris"
            :options="{
              ripple: true,
              href: { name: `Parrainage` },
              click: page.jeMinscrisClick
            }"
            :sm="{ click: page.jeMinscrisClickOnSm }"
            :xs="{ click: page.jeMinscrisClickOnXs }">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.containerPromoParrainage.container9.jeMinscris.value', `Parrainer`)" />
          </ka-button>
        </ka-container>
      </ka-container>
      <!-- Tableau par2 -->
      <ka-container code="tableau-par-2">
        <!-- Ligne 8 -->
        <ka-container code="ligne-8">
          <ka-text code="taille">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.ligne8.taille.value', `Taille`)" />
          </ka-text>
          <ka-text code="il-ny-a-pas-un-nombre">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.ligne8.ilNyAPasUnNombre.value', `Il n’y a pas un nombre de questions demandé, c’est à vous de faire une estimation en fonction du nombre d’heures que vous avez réalisées. `)" />
          </ka-text>
          <ka-text code="de-2-a-10-sections">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.ligne8.de2A10Sections.value', `De 2 à 10 sections.<br>Le séquençage peut-être fait d’après les différentes parties du programme de formation.`)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 9 -->
        <ka-container code="ligne-9">
          <ka-text code="objectifs">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.ligne9.objectifs.value', `Objectifs`)" />
          </ka-text>
          <ka-text code="observer-ce-que-les">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.ligne9.observerCeQueLes.value', `Observer ce que les stagiaires ont retenu de la formation. `)" />
          </ka-text>
          <ka-text code="evaluer-les-stagiaires">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.ligne9.evaluerLesStagiaires.value', `Évaluer les stagiaires afin de savoir s’ils sont montés en compétences de manière opérationnelle. `)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 11 -->
        <ka-container code="ligne-11">
          <ka-text code="necessite">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.ligne11.necessite.value', `Nécessité`)" />
          </ka-text>
          <ka-text code="indispensable-pour">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.ligne11.indispensablePour.value', `<ul><li>Indispensable pour <strong>clôturer la formation</strong> et déclencher la facturation des experts.</li><li>Requis pour maintenir la formation conforme aux exigences de la certification Qualiopi.</li></ul>`)" />
          </ka-text>
        </ka-container>
        <!-- Ligne 11 -->
        <ka-container code="container-10">
          <ka-text code="tutoriel">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.container10.tutoriel.value', `Tutoriel`)" />
          </ka-text>
          <ka-text code="par-defaut-il-y-5">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.container10.parDefautIlY5.value', page.$constants.parDefautIlY5)" />
          </ka-text>
          <ka-text code="pour-la-mise-en-forme">
            <span v-html="t('expertRessource7Evaluation.ressourcesExperts.tableauPar2.container10.pourLaMiseEnForme.value', `Pour la mise en forme de l’évaluation, nous vous recommandons de mentionner <strong>“réalisés avec succès”, “réalisé partiellement”, “non acquis”</strong>. <br> <br>Pour information <strong>cette évaluation ne pourra pas être vu par les stagiaires</strong>. Vous pouvez vous aider de l’exemple en bas du tableau.<br> `)" />
          </ka-text>
        </ka-container>
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image 3`
          }"
          value="https://ucarecdn.com/8b0e2d3e-c52e-431b-9793-849a07ea9dd9/" />
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { expertRessourcesEvaluations } from './store'
import BlocPreviewRessourceSansDescription from '~/components/BlocPreviewRessourceSansDescription/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p122')
const appData = appDataStore()
const page = expertRessourcesEvaluations()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
